import { useNavigate } from "react-router-dom"

import { AccountSettingsProfile } from "modals/AccountSettingsProfile"

import { AccountRoutePanel } from "./shared"

export const ContractorProfilePage = () => {
  const navigate = useNavigate()

  return (
    <AccountRoutePanel>
      <AccountSettingsProfile onCancel={() => navigate(-1)} />
    </AccountRoutePanel>
  )
}
